// A chat's mode picks its model; the chat stores the model as its provider.
// Keep in step with MODE_MODELS in api/engine.py.
export const MODE_MODELS: Record<string, string> = {
  fast: 'gpt-6-luna',
  expert: 'gpt-5.6-sol',
};

export const DEFAULT_MODE = 'fast';

export function providerForMode(mode?: string): string {
  return MODE_MODELS[mode || DEFAULT_MODE] || MODE_MODELS[DEFAULT_MODE];
}
